import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import {
  ApprovalReportItem,
  ApprovalReportItemType,
  ApprovalReportProductionDowntimeItem,
  ApprovalReportProductionOrderPhaseType,
  KpiStatus
} from 'chronos-core-client';
import { ApproveReportTableColumn } from './approve-report-table-column';

@Component({
  selector: 'app-approve-report-table',
  templateUrl: './approve-report-table.component.html',
  styleUrls: ['./approve-report-table.component.scss']
})
export class ApproveReportTableComponent {
  @Input() public tableData: TreeNode[] = [];
  @Input() public buttonTemplate: TemplateRef<any>;

  @Output() public infoLinkClicked = new EventEmitter<ApprovalReportItem | ApprovalReportProductionDowntimeItem>();
  @Output() public loadNodeClicked = new EventEmitter<any>();
  @Output() public tableExpandClicked = new EventEmitter<boolean>();
  @Output() public consumePalletLinkClicked = new EventEmitter<any>();

  public tableExpanded = false;

  public readonly KPI_STATUS = KpiStatus;
  public readonly ITEM_TYPE = ApprovalReportItemType;
  public readonly PHASE_TYPE = ApprovalReportProductionOrderPhaseType;

  public columns: ApproveReportTableColumn[] = [
    { label: 'APPROVE.STATUS', styleClass: 'tiny-cell', highlighted: false },
    { label: 'APPROVE.INFO', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.ORDER_TYPE', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.CUSTOMER_CODE', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.ABG_FINISHED', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.START_TIME', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.END_TIME', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.SETUP_TIME', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.RUN_TIME', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.DOWN_TIME', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.GOOD_QTY', styleClass: 'medium-cell', highlighted: false },
    { label: 'APPROVE.WASTE', styleClass: 'medium-cell', highlighted: false },
    { label: 'APPROVE.MACULATURE', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.PLANNED_GOOD_QTY', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.OVERALL_GOOD_QTY', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.GOOD_QUANTITY_PREDECESSOR', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.CONSUMPTION', styleClass: 'large-cell', highlighted: false },
    { label: 'APPROVE.ORDER_GROSS_QUANTITY', styleClass: 'small-cell', highlighted: false },
    { label: 'APPROVE.OUTPUT1', styleClass: 'medium-cell', highlighted: false },
    { label: 'APPROVE.OUTPUT2', styleClass: 'medium-cell', highlighted: false }
  ];

  public onHighlight(column: ApproveReportTableColumn): void {
    if (this.columns.indexOf(column) < 3) {
      return;
    }
    column.highlighted = !column.highlighted;

    this.logHighlightColumnHeight();
  }

  public emitInfoEvent(item: ApprovalReportItem | ApprovalReportProductionDowntimeItem): void {
    this.infoLinkClicked.emit(item);
  }

  public loadNode(event: any): void {
    this.loadNodeClicked.emit(event);
    this.checkHighlighted(100);
  }

  public closeNode(event: any): void {
    this.checkHighlighted(100);
  }

  public expandCollapseTable(): void {
    this.tableExpanded = !this.tableExpanded;
    this.tableExpandClicked.emit(this.tableExpanded);
    this.checkHighlighted(100);
  }

  private checkHighlighted(setDelay: number = 0): void {
    const highlightedElements = document.querySelectorAll('.highlighted');
    if (highlightedElements.length > 0) {
      this.logHighlightColumnHeight(setDelay);
    }
  }

  private logHighlightColumnHeight(setDelay: number = 0): void {
    setTimeout(() => {
      const highlightColumnHeight = this.calculateHighlightColumnHeight();

      this.updateHighlightedElements(highlightColumnHeight);
    }, setDelay);
  }

  private calculateHighlightColumnHeight(): number {
    const thead = document.querySelector('.p-treetable-scrollable-header');
    const tbody = document.querySelector('.p-treetable-scrollable-body');
    const tbodyHeight = tbody?.clientHeight || 0;
    const theadHeight = thead?.clientHeight || 0;

    return tbodyHeight + theadHeight;
  }

  private updateHighlightedElements(height: number): void {
    const highlightedElements = document.querySelectorAll('.highlighted');
    highlightedElements.forEach((element) => {
      (element as HTMLElement).style.setProperty('--highlight-height', `${height}px`);
    });
  }
}
